import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

/**
 * Avatar represents people using icons, labels and images.
 */
@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'hostClasses()',
    '[attr.aria-label]': 'ariaLabel()',
    '[attr.aria-labelledby]': 'ariaLabelledBy()',
    '[attr.data-size]': 'size()',
    '[attr.data-shape]': 'shape()',
  },
})
export class AvatarComponent {
  private readonly imageFailed = signal(false);

  protected readonly hostClasses = computed(() => {
    const classes = ['avatar', `avatar--${this.shape()}`, `avatar--${this.size()}`];
    if (this.styleClass()) {
      classes.push(this.styleClass());
    }
    return classes.join(' ');
  });

  protected readonly displayImageSrc = computed(() => {
    if (this.imageFailed()) {
      return this.fallbackImage();
    }
    return this.image() || this.fallbackImage();
  });

  readonly label = input<string>();
  readonly icon = input<string>();
  readonly image = input<string | SafeUrl>();
  readonly fallbackImage = input<string>('assets/images/app/profile.PNG');
  readonly size = input<'normal' | 'large' | 'xlarge'>('normal');
  readonly shape = input<'square' | 'circle'>('square');
  readonly styleClass = input<string>('');
  readonly ariaLabel = input<string>();
  readonly ariaLabelledBy = input<string>();

  protected imageError(): void {
    this.imageFailed.set(true);
  }
}
